import type {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import type {SmtpCredentialsTestRun} from '../types/SmtpCredentialsTestRun';

export type SmtpTestOverallPresentation = {
  label: string;
  colorScheme: ColorSchemeType;
  isPassing: boolean;
};

export function getSmtpTestOverallPresentation(
  run: Pick<SmtpCredentialsTestRun, 'overallStatus' | 'isTimedOut'>
) {
  return match(run)
    .returnType<SmtpTestOverallPresentation>()
    .with({isTimedOut: true}, () => ({
      label: i18n.t('entity.emailService.labels.testTimedOut'),
      colorScheme: 'red',
      isPassing: false,
    }))
    .with({overallStatus: smtpCredentialsTestStatus.done}, () => ({
      label: i18n.t('entity.emailService.labels.testOverallDone'),
      colorScheme: 'green',
      isPassing: true,
    }))
    .with({overallStatus: smtpCredentialsTestStatus.warning}, () => ({
      label: i18n.t('entity.emailService.labels.testOverallWarning'),
      colorScheme: 'orange',
      isPassing: true,
    }))
    .with({overallStatus: smtpCredentialsTestStatus.failed}, () => ({
      label: i18n.t('entity.emailService.labels.testOverallFailed'),
      colorScheme: 'red',
      isPassing: false,
    }))
    .with({overallStatus: smtpCredentialsTestStatus.inProgress}, () => ({
      label: i18n.t('entity.emailService.labels.testOverallInProgress'),
      colorScheme: 'blue',
      isPassing: false,
    }))
    .otherwise(() => ({
      label: i18n.t('entity.emailService.labels.testOverallUnknown'),
      colorScheme: 'neutral',
      isPassing: false,
    }));
}
